exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-container {\n  overflow: hidden; }\n  .input-container .input {\n    float: left;\n    clear: both;\n    padding: 3px;\n    width: 100%;\n    height: 50px;\n    font-size: 1.2em;\n    background: #363636;\n    color: #eeeeee;\n    border: 0;\n    border-bottom: 2px solid #aaaaaa;\n    overflow: hidden; }\n    .input-container .input.invalid {\n      border-bottom: 2px solid #E67373; }\n  .input-container .errors {\n    min-height: 1.7em;\n    float: left;\n    clear: both;\n    padding-top: .5em;\n    overflow: hidden; }\n    .input-container .errors .error {\n      font-size: .9em;\n      color: #E67373; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/InputComponent/input.component.scss
// module id = ./src/app/common/components/InputComponent/input.component.scss
// module chunks = main